<template>
  <div class="contacts-panel">
    <!-- Header -->
    <div class="cp-header">
      <div style="display:flex;align-items:center">
        <span class="cp-title">Contactos</span>
        <span class="cp-count">{{ contacts.length }}</span>
      </div>
      <button type="button" class="cp-add-btn" @click="$emit('add-contact')">
        <PlusIcon :size="14" />
        Agregar
      </button>
    </div>

    <!-- Empty state -->
    <div v-if="contacts.length === 0" class="cp-empty">
      <UserIcon :size="48" color="#e8e7e3" />
      <p class="cp-empty-text">Sin contactos a&uacute;n</p>
      <button type="button" class="cp-empty-btn" @click="$emit('add-contact')">
        Agregar el primero
      </button>
    </div>

    <!-- Contacts list -->
    <div v-else>
      <!-- Search (only if > 3 contacts) -->
      <div v-if="contacts.length > 3" class="cp-search">
        <el-input
          v-model="searchQuery"
          placeholder="Buscar contacto..."
          suffix-icon="el-icon-search"
          size="mini"
          clearable
        />
      </div>

      <div
        v-for="(contact, index) in visibleContacts"
        :key="contact.id || index"
        class="contact-item"
        @click="$emit('select-contact', contact)"
      >
        <div
          class="c-av"
          :style="{ background: getAvatarColor(index), color: '#fff' }"
        >
          {{ getInitials(contact.name) }}
        </div>
        <div class="c-info">
          <p class="c-name">{{ contact.name }}</p>
          <p class="c-role">{{ contact.position || contact.email }}</p>
        </div>
        <button
          type="button"
          class="c-edit"
          @click.stop="$emit('select-contact', contact)"
        >
          <Edit2Icon :size="14" />
        </button>
      </div>

      <!-- View all footer -->
      <div v-if="contacts.length > maxVisible" class="cp-footer">
        <a @click="$emit('view-all')"
          >Ver todos los contactos ({{ contacts.length }})</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { PlusIcon, UserIcon, Edit2Icon } from "@/components/Icons/LucideIcons";

const AVATAR_COLORS = [
  "#6366f1",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#3fdbbf",
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#06b6d4",
  "#31355c"
];

export default {
  name: "ContactsPanel",
  components: { PlusIcon, UserIcon, Edit2Icon },
  props: {
    contacts: { type: Array, default: () => [] }
  },
  data() {
    return {
      searchQuery: "",
      maxVisible: 6
    };
  },
  computed: {
    filteredContacts() {
      if (!this.searchQuery) return this.contacts;
      const q = this.searchQuery.toLowerCase();
      return this.contacts.filter(
        c =>
          (c.name && c.name.toLowerCase().includes(q)) ||
          (c.email && c.email.toLowerCase().includes(q))
      );
    },
    visibleContacts() {
      return this.filteredContacts.slice(0, this.maxVisible);
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return "??";
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.substring(0, 2).toUpperCase();
    },
    getAvatarColor(index) {
      return AVATAR_COLORS[index % AVATAR_COLORS.length];
    }
  }
};
</script>

<style lang="scss" scoped></style>
